import type { ShippingPrice } from "@components/commerce/order/types";
import { useAuth } from "@lib/auth/useAuth";
import { QueryKeys } from "@lib/enums/QueryKeys";
import { ClientFetchService } from "@lib/helpers/clientFetchService";
import { useApi } from "@lib/helpers/useApi";
import { useStore } from "@store/store";

export const fetchShippingMethods = (cartId = ""): Promise<ShippingPrice[]> =>
    ClientFetchService.get<ShippingPrice[]>(`/api/checkout/shipping-methods?cartId=${cartId}`);

export const useShippingMethods = () => {
    const { status } = useAuth();
    const cartId = useStore((state) => state.data.me.cartInfo.cart?.id);

    return useApi.useAsync<ShippingPrice[]>(
        [QueryKeys.getDeliveryMethods, { cartId }],
        () => fetchShippingMethods(cartId),
        { enabled: !!cartId && status === "authenticated" }
    );
};
